import { transformUnits } from '@/helpers/unit-formatter/unit-formatter';
import {
  FormattedUnitLabels,
  UnitFormatterType,
  UnitValue,
} from '@/helpers/unit-formatter/unit-formatter.types';
import {
  formatNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/unit-formatter.utils';

import { resolveUnitPrecision } from './formatter-precision';
import { SUPPORTED_UNITS } from '../unit-formatter.constants';

const createPrecisionUnitFormatter =
  (outputLabel: string, unitKey: string, fallbackPrecision = 2): UnitFormatterType =>
  (unitValue: UnitValue, displayUnits?: string): FormattedUnitLabels => {
    const transformed = transformUnits(unitValue, displayUnits);
    const precision = resolveUnitPrecision({
      units: unitKey,
      fallbackPrecision,
    });

    return unitValueToFormattedUnitLabels({
      value: formatNumber(transformed.value, precision),
      units: outputLabel,
    });
  };

export const formatFt = createPrecisionUnitFormatter('ft', SUPPORTED_UNITS.FT);
export const formatGpm = createPrecisionUnitFormatter('gpm', SUPPORTED_UNITS.GPM);
